var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function NoinkIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1951 11.5644L12.5119 5.32599C12.2554 4.89134 11.6267 4.89134 11.3702 5.32599L7.687 11.5658C7.68145 11.5804 7.67452 11.5949 7.6662 11.6095C7.23085 12.3734 7 13.2414 7 14.119C7 16.8864 9.21766 19.138 11.9414 19.1387C14.6658 19.138 16.8828 16.8871 16.8828 14.119C16.8828 13.2414 16.6526 12.3734 16.2159 11.6095C16.2076 11.5949 16.2006 11.5804 16.1951 11.5644Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_8827_19178",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6.13318,
    width: 19.1865,
    height: 12.2321,
    fill: ""
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3,
    y: 6.13318,
    width: 19.1865,
    height: 12.2321
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.86523L3.5 6.99921L21.3452 17.3022L20.8452 18.1682L3 7.86523Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.86523L3.5 6.99921L21.3452 17.3022L20.8452 18.1682L3 7.86523Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.86523L20.8452 18.1682L21.8452 16.4361L4 6.13318L3 7.86523Z",
    fill: "white",
    mask: "url(#path-2-outside-1_8827_19178)"
  }));
}
export var NoinkIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: NoinkIconInner
  }, props));
};